export const colors = {
  primary: "#161b2d",
  lightBlue: "#89afed"
};
